import React from "react";
import { Button, Input, Select, Space } from "antd";
import { FilterOutlined } from "@ant-design/icons";

const readFilter = (value) => value ? JSON.parse(value) : { presence: "all", search: "" };

export const notesColumnFilter = {
  filterDropdown: ({ selectedKeys, setSelectedKeys, confirm, clearFilters }) => {
    const filter = readFilter(selectedKeys[0]);
    const update = (change) => {
      const next = { ...filter, ...change };
      setSelectedKeys(next.presence === "all" && !next.search ? [] : [JSON.stringify(next)]);
    };
    return (
      <div style={{ padding: 12, width: 280 }} onKeyDown={(event) => event.stopPropagation()}>
        <Select aria-label="Notizen filtern" value={filter.presence}
          onChange={(presence) => update({ presence })} style={{ width: "100%", marginBottom: 8 }}
          options={[
            { label: "Alle", value: "all" },
            { label: "Notizen", value: "with" },
            { label: "Keine Notizen", value: "without" },
          ]} />
        <Input aria-label="Notizen durchsuchen" placeholder="Notizen durchsuchen"
          value={filter.search} allowClear onChange={(event) => update({ search: event.target.value })}
          onPressEnter={() => confirm()} style={{ marginBottom: 8 }} />
        <Space>
          <Button type="primary" size="small" onClick={() => confirm()}>Anwenden</Button>
          <Button size="small" onClick={() => { clearFilters?.(); confirm(); }}>Zurücksetzen</Button>
        </Space>
      </div>
    );
  },
  filterIcon: (filtered) => <FilterOutlined style={{ color: filtered ? "#3FB6C2" : undefined }} />,
  onFilter: (value, record) => {
    const { presence, search } = readFilter(value);
    const notes = (record.notizen ?? "").trim();
    const presenceMatches = presence === "all" || (presence === "with" ? notes.length > 0 : notes.length === 0);
    return presenceMatches && notes.toLocaleLowerCase("de-DE").includes(search.trim().toLocaleLowerCase("de-DE"));
  },
  render: (value) => value?.trim() || "-",
};
